module.exports = __webpack_public_path__ + "2021315:5185b0787db23a9cf11c/img/heroMobile@2x.4de184f.png";